export default class StorageCalendar {

	constructor (data) {
		this.data = data
	}

	static async fetch (db_name, storage_id, year) {

		let payload = await Anvil.REST.get(`/c_order/terminal/fetch_ntak_calendar_2/${db_name}/${storage_id}/${year}`)

		return new StorageCalendar(payload.data)
	}
}
